import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 1023px)';

function getInitialValue(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const matchMediaMobile =
    typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches;
  const viewportMobile = window.innerWidth <= 1023;

  return matchMediaMobile || viewportMobile;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => getInitialValue());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery =
      typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_QUERY) : null;
    const updateMatch = () => {
      const mediaMatch = mediaQuery?.matches ?? false;
      const viewportMatch = window.innerWidth <= 1023;
      setIsMobile(mediaMatch || viewportMatch);
    };

    updateMatch();
    mediaQuery?.addEventListener('change', updateMatch);
    window.addEventListener('resize', updateMatch);

    return () => {
      mediaQuery?.removeEventListener('change', updateMatch);
      window.removeEventListener('resize', updateMatch);
    };
  }, []);

  return isMobile;
}
